// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./.yarn/cache/regenerator-runtime-npm-0.13.11-90bf536060-d493e9e118.zip/node_modules/regenerator-runtime/runtime.js");
__webpack_require__("./src/utils/globals.js");
var __webpack_exports__ = __webpack_require__("./src/index.js");
